import { createSelector } from 'reselect'
const busSeatsGoingSelector = ({ busSeatsGoing }) => busSeatsGoing
const busSeatsReturnSelector = ({ busSeatsReturn }) => busSeatsReturn

const busViagemIdaSelector = ({ poltronasIda }) => poltronasIda
const busViagemVoltaSelector = ({ poltronasVolta }) => poltronasVolta

const getSelectedBusSeatsGoing = createSelector(
	[busViagemIdaSelector],
	(busSeats) => busSeats.filter(({ available }) => !available)
)

const getUltimoOnibusSelecionadoGoing = createSelector(
	[busSeatsGoingSelector],
	(busSeats) => busSeats.filter(({ available }) => !available)
)

const getSelectedViagemIda = createSelector(
	[busViagemIdaSelector],
	(busSeats) => busSeats.filter(({ available }) => !available)
)

const getSelectedViagemVolta = createSelector(
	[busViagemVoltaSelector],
	(busSeats) => busSeats.filter(({ available }) => !available)
)

const getSelectedBusSeatsReturn = createSelector(
	[busViagemVoltaSelector],
	(busSeats) => busSeats.filter(({ available }) => !available)
)

const getNumberOfPassengers = createSelector(
	[getUltimoOnibusSelecionadoGoing],
	(busSeats) => busSeats.length
)

const Selectors = {
	getNumberOfPassengers,
	getSelectedBusSeatsGoing,
	getSelectedBusSeatsReturn,
	getSelectedViagemIda,
	getSelectedViagemVolta,
}

export default Selectors
